import { DateOnly } from '@if/core/date'
import { loanDashboardQueryKeys } from '@src/api/loan/loan-dashboard-api'
import { apiClient } from '@src/services/http-common'
import type { TestLoanGenerated, TestLoanPreviewResult, TestLoanRequest } from '@src/types/test-loan'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const PREVIEW_ROUTE = 'dev-tools/test-loans/preview'
const GENERATE_ROUTE = 'dev-tools/test-loans/generate'

interface TestLoanPreviewResultDto {
  paymentAmount: number
  pastPayments: { effectiveDate: string; amount: number }[]
}

// DateOnly serializes to YYYY-MM-DD through toJSON, so the request posts as-is.
const postPreview = async (request: TestLoanRequest): Promise<TestLoanPreviewResult> => {
  const response = await apiClient.post<TestLoanPreviewResultDto>(PREVIEW_ROUTE, request)
  return {
    paymentAmount: response.data.paymentAmount,
    pastPayments: response.data.pastPayments.map((p) => ({ effectiveDate: new DateOnly(p.effectiveDate), amount: p.amount })),
  }
}

const postGenerate = async (request: TestLoanRequest): Promise<TestLoanGenerated> => {
  const response = await apiClient.post<TestLoanGenerated>(GENERATE_ROUTE, request)
  return response.data
}

export function usePreviewTestLoan() {
  return useMutation({ mutationFn: postPreview })
}

export function useGenerateTestLoan() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: postGenerate,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: loanDashboardQueryKeys.all })
    },
  })
}
